
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/win-a-cruise-around-the-world",
      function () {
        return require("private-next-pages/landing/win-a-cruise-around-the-world.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/win-a-cruise-around-the-world"])
      });
    }
  